import { FilterDropdown } from "@repo/ui";

import type { DropDownProps } from ".";
interface Props extends DropDownProps {
	allOption?: boolean;
}

export function BrandsDropdown(props: Props) {
	const { allOption = true } = props;

	if (props.loaded && (props.options?.data?.length ?? 0) <= 1) return null;
	return (
		<FilterDropdown
			{...props}
			id="brandIds"
			allOption={allOption}
			values={props.options?.data ?? []}
			objectName="Brands"
			fullLength
			isMulti
		/>
	);
}
